
import { Component, Prop, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import DialogSetStaff from "../../staff/components/setStaff.vue";
import { Qiniu } from "@/types/qiniu";
import { getQiniuToken } from "@/api/third";
import {
  addProjectTask,
  editorProjectTask,
  getProjectTaskCollectDetail,
  getProjectTaskDetail,
} from "@/api/project";

@Component({
  name: "setShifts",
  components: {
    DialogSetStaff,
  },
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })
  dialogAddProjectTaskVisible!: Boolean;
  @Prop({
    type: Number,
    default: 1,
  })
  type!: Number;
  @Prop({
    type: Object,
    default: () => {},
  })
  editData!: any;

  private formTask: any = {
    type: "2",
    name: "",
    customer: "",
    manager: "",
    startTime: "",
    endTime: "",
    desp: "",
    fileList: [],
    fileEdit: [],
  };
  private projectAlias = UserModule.getCompany.project_alias
    ? UserModule.getCompany.project_alias
    : "项目";
  private projectTaskAlias = UserModule.getCompany.project_task_alias
    ? UserModule.getCompany.project_task_alias
    : "任务";
  private projectTaskCollectAlias = UserModule.getCompany
    .project_task_collect_alias
    ? UserModule.getCompany.project_task_collect_alias
    : "任务集";

  private isHaveTaskCollect=UserModule.getCompany ? parseInt(UserModule.getCompany.is_open_project_task_collect) === 1 : false

  private editDataCustomer: any = {};

  private staffEnterType = 10;
  private dialogSetStaffVisible = false;
  private selectStaffArray: any = [];
  private selectManagerArray: any = []; // 新建项目 负责人

  // 骑牛
  private qiuniuToken: any = {
    action_url: "",
  };
  private qiuniuform = {};

  created() {
    const params = {
      type: Qiniu.UPLOAD_TYPE_PROJECT,
    };
    getQiniuToken(params).then((res) => {
      if (res && res.data) {
        this.qiuniuToken = res.data;
      }
    });
    switch (this.type) {
      case 1:
        this.formTask.customer = this.editData.customer_name;

        break;
      case 2:
        this.formTask = {
          type: parseInt(this.editData.is_task_collect) === 1 ? "1" : "2",
          name: this.editData.name,
          customer: this.editData.customer_name,
          manager: "",
          startTime: this.editData.plan_start_date_time + "000",
          endTime: this.editData.plan_end_date_time + "000",
          desp: this.editData.describe,
          fileList: [],
          fileEdit: [],
        };
        this.editData.user_list.forEach((element: any) => {
          let manager: any = {};
          manager.id = element.user_id;
          manager.name = element.user_name;
          manager.mobile = element.mobile;
          this.selectManagerArray.push(manager);
        });
        if (parseInt(this.editData.is_task_collect) === 1) {
          this.getProjectTaskCollectDetail(
            this.editData.project_id,
            this.editData.id
          );
        } else {
          this.getProjectTaskDetail(this.editData.project_id, this.editData.id);
        }
        break;
    }
  }
  private getProjectTaskCollectDetail(id: any, taskId: any) {
    let _ = this;
    let pamars: any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.project_id = id;
    pamars.project_task_id = taskId;
    getProjectTaskCollectDetail(pamars).then((res: any) => {
      this.formTask.fileEdit = res.data.resources_list;
    });
  }
  private getProjectTaskDetail(id: any, taskId: any) {
    let _ = this;
    let pamars: any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.project_id = id;
    pamars.project_task_id = taskId;
    getProjectTaskDetail(pamars).then((res: any) => {
      this.formTask.fileEdit = res.data.resources_list;
    });
  }
  private resourceClick(val: any) {
    window.open(val.url);
  }
  beforeRemove(file: any, fileList: any) {
    return this.$confirm(`确定移除 ${file.name}？`);
  }
  handleRemove(file: any, fileList: any) {}
  handlePreview(file: any) {}
  handleExceed(files: any, fileList: any) {
    // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
  }

  private managerStaff(val: any) {
    this.selectManagerArray = val;
  }
  private delManagerHandle(val: any) {
    this.selectManagerArray.splice(this.selectManagerArray.indexOf(val), 1);
  }
  private closeStaffHandle(val: any) {
    this.dialogSetStaffVisible = val;
  }
  private managerStaffSelected() {
    this.dialogSetStaffVisible = true;
    if (this.formTask.type === "1") {
      this.staffEnterType = 10;
    } else {
      this.staffEnterType = 11;
    }

    this.selectStaffArray = this.selectManagerArray;
  }
  // qiniu
  private uploadSuccess(res: any, file: any, fileList: any) {
    this.formTask.fileList = fileList;
  }
  private beforeUpload(file: any) {
    // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    // const isLt2M = file.size / 1024 / 1024 < 5;
    // if (!isJPG) {
    //   return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    // }
    // if (!isLt2M) {
    //   return this.$message.error('上传图片大小不能超过 5MB!');
    // }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      this.qiuniuform = {
        token: this.qiuniuToken.uptoken,
        domain: this.qiuniuToken.domain,
      };
    });
  }
  private formHandle() {
    if (!this.formTask.name) {
      this.showErrorMsg(
        "请输入" +
          (this.formTask.type === "1"
            ? this.projectTaskCollectAlias + "名称"
            : this.projectTaskAlias + "名称")
      );
      return;
    }
    if (!this.selectManagerArray || this.selectManagerArray.length < 1) {
      this.showErrorMsg("请选择负责人");
      return;
    }
    if (!this.formTask.startTime) {
      this.showErrorMsg("请选择计划开始时间");
      return;
    }
    if (!this.formTask.endTime) {
      this.showErrorMsg("请选择计划结束时间");
      return;
    }
    if (this.formTask.startTime > this.formTask.endTime) {
      this.showErrorMsg("计划开始时间晚于计划结束时间");
      return;
    }
    let fileList: any = [];
    if (this.formTask.fileList) {
      this.formTask.fileList.forEach((element: any) => {
        let fileData: any = {};
        fileData.name = element.raw.name;
        fileData.content = element.response.key;
        if (element.raw.type.includes("image")) {
          fileData.type = 1;
          fileList.push(fileData);
        } else if (element.raw.type.includes("video")) {
          fileData.type = 3;
          fileList.push(fileData);
        } else {
          fileData.type = 4;
          fileList.push(fileData);
        }
      });
    }
    let managerList: any = [];
    this.selectManagerArray.forEach((element: any) => {
      let manager: any = {};
      manager.id = element.id;
      manager.name = element.name;
      manager.mobile = element.mobile;
      managerList.push(manager);
    });

    let pamars: any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.name = this.formTask.name;

    pamars.plan_start_date_time =
      parseInt(this.formTask.startTime / 1000 + "") + 86399;
    pamars.plan_end_date_time =
      parseInt(this.formTask.endTime / 1000 + "") + 86399;
    pamars.describe = this.formTask.desp;

    pamars.manager_users = JSON.stringify(managerList);

    if (fileList && fileList.length > 0) {
      pamars.resources = JSON.stringify(fileList);
    }
    if (this.type === 2) {
      pamars.is_task_collect = this.formTask.type === "1" ? "1" : "0";
      pamars.project_id = this.editData.project_id;
      pamars.project_task_id = this.editData.id;
      editorProjectTask(pamars)
        .then((res: any) => {
          this.showSuccessMsg(res.msg);
          this.close();
          this.$emit("finishAdd");
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    } else {
      pamars.is_task_collect = this.formTask.type === "1" ? "1" : "0";
      if (this.editData.is_project === 1) {
        pamars.project_id = this.editData.id;
      } else {
        pamars.project_id = this.editData.project_id;
        pamars.project_task_id = this.editData.id;
      }
      addProjectTask(pamars)
        .then((res: any) => {
          this.showSuccessMsg(res.msg);
          this.close();
          this.$emit("finishAdd");
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    }
  }
  private close() {
    this.$emit("close", false);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "success",
    });
  }
}
